export default __webpack_public_path__ + "static/SectionTwo_01_01@2x-9970fb8c652dd68911141a7a529c1d33.png";